module.exports = __webpack_public_path__ + "img/loading.cd5e6c6c.gif";